<template>
  <v-container style="margin-left: -25px;
    margin-top: -20px;">
    <h2 class="page-title-bar">
      <i class="ico ico-system"></i>{{ $t('PDA Settings') }}
    </h2>
    <!-- Dynamic Function Groups -->
    <div v-for="group in functionGroups" :key="group.key">
      <v-row class="mt-10">
        <v-col cols="12">
          <h3 class="group-title">{{ group.title }}</h3>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col
          v-for="(item, i) in group.items"
          :key="i"
          cols="6"
          sm="4"
          md="4"
          lg="2"
          style="padding: 4px;"
        >
          <v-card
            outlined
            class="function-card d-flex align-center pa-6 text-center elevation-4"
            :class="{ selected: item.state, unselected: !item.state }"
            @click="toggleSelect(group.key, i)"
          >
            <div class="icon-container">
              <v-icon v-if="item.state" color="#001E38">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-radiobox-blank</v-icon>
            </div>
            <div class="card-content">
              <!-- SVG Icon -->
               <div>
                   <img
                   :src="require(`@/assets/icons/${item.svg}`)"
                   :alt="item.label"
                   class="custom-icon"
                      />
                </div>
              <span class="text-caption" style="font-weight: 600;">{{ item.label }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- Save Button -->
    <v-row class="mt-8">
      <v-col cols="12" class="text-left">
        <v-btn :disabled="PDAButtonConfigSave" class="btn" @click="PDAConfigSave"> {{ $t("Save") }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import config from '@/plugins/configs'
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus.js'

// import commons from '@/plugins/commons'
export default {
  data () {
    return {
      functionGroups: [
        {
          key: 'assignFunctions',
          title: 'ASSIGN FUNCTION',
          items: [
            { label: this.$t('Assign'), name: 'ESL_ASSIGN', svg: 'Assign.svg', state: true },
            { label: this.$t('Multi Assign'), name: 'ESL_MULTIASSIGN', svg: 'Multi_Assign.svg', state: true },
            { label: this.$t('Unassign'), name: 'ESL_UNASSIGN', svg: 'Unassign.svg', state: true },
            { label: this.$t('Extra Info Assign'), name: 'ESL_EXTRAINFOASSIGN', svg: 'extra_assign.svg', state: true },
            { label: this.$t('Assign with Template'), name: 'ASSIGN_WITH_TEMPLATE', svg: 'Assign_with_Template.svg', state: true }
          ]
        },
        {
          key: 'defaultFunctions',
          title: 'DEFAULT FUNCTION',
          items: [
            { label: this.$t('Product Info'), name: 'ESL_PRODUCTINFO', svg: 'Product_Info.svg', state: true },
            { label: this.$t('Label Info'), name: 'ESL_LABELINFO', svg: 'Label_Info.svg', state: true },
            { label: this.$t('Blinking by Product'), name: 'ESL_BLINKINGBYPRODUCT', svg: 'Blinking_by_Product.svg', state: true },
            { label: this.$t('Blinking by Label'), name: 'ESL_BLINKINGBYLABEL', svg: 'Blinking_by_Label.svg', state: true },
            { label: this.$t('Page Flipping'), name: 'ESL_PAGEFLIPPING', svg: 'Page_Flipping.svg', state: true }
          ]
        },
        {
          key: 'powerRail',
          title: 'POWER RAIL',
          items: [
            { label: this.$t('Assign'), name: 'POWER_RAIL_ASSIGN', svg: 'PowerRailAssign.svg', state: true },
            { label: this.$t('Unassign'), name: 'POWER_RAIL_UNASSIGN', svg: 'PowerRailUnAssign.svg', state: true }
          ]
        },
        {
          key: 'sensor',
          title: 'SENSOR',
          items: [
            { label: this.$t('Assign'), name: 'SENSOR_ASSIGN', svg: 'SensorAssign.svg', state: true },
            { label: this.$t('Unassign'), name: 'SENSOR_UNASSIGN', svg: 'SensorUnAssign.svg', state: true }
          ]
        }
      ],
      PDAButtonConfigSave: false
    }
  },
  mounted () {
    // // PDA Button Config : Save
    this.$store.dispatch('auth/getDisabledBtn', '9601').then(flag => {
      this.PDAButtonConfigSave = flag
    })
    this.togetPDAConfigButtonState()
  },
  methods: {
    toggleSelect (groupKey, index) {
      const group = this.functionGroups.find((g) => g.key === groupKey)
      if (group) group.items[index].state = !group.items[index].state
    },
    togetPDAConfigButtonState () {
      const config = { params: {} }
      this.$utils
        .callAxios(
          codes.requests.getPdaButtons.method,
          codes.requests.getPdaButtons.url,
          config
        )
        .then(res => {
          const result = res.data
          if (result.responseCode !== 200) {
            console.warn('Failed to fetch PDA configuration:', result.responseMessage)
            return
          }
          const buttonStates = result.data?.buttonConfiguration || []
          this.functionGroups.forEach(group => {
            group.items.forEach(item => {
              const matchedButton = buttonStates.find(b => b.name === item.name)
              if (matchedButton) {
                item.state = matchedButton.state
              }
            })
          })
        })
        .catch(error => {
          console.warn('Could not load PDA configuration:', error)
        })
    },

    PDAConfigSave () {
      const buttonConfiguration = this.functionGroups.flatMap(group =>
        group.items.map(item => ({
          name: item.name,
          state: item.state
        }))
      )
      const data = { buttonConfiguration }
      const config = { params: {} }
      if (!buttonConfiguration.length) {
        EventBus.$emit('messageAlert', this.$t('No buttons to save.'))
        return
      }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updatePdaButtons.method,
          codes.requests.updatePdaButtons.url,
          data,
          config
        )
        .then(res => {
          const result = res.data
          if (result.responseCode === 200) {
            EventBus.$emit('messageAlert', this.$t('Saved successfully'))
            this.togetPDAConfigButtonState()
          } else {
            EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          }
        })
        .catch(error => {
          const message =
        error?.response?.data?.responseMessage || 'Something went wrong'
          EventBus.$emit('messageAlert', this.$t(message))
        })
    }

  }
}
</script>
<style scoped>
.page-title-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.group-title {
  word-spacing: 3px;
  font-size: var(--font18);
  line-height: 1.5;
  color: #001E38;
}
.function-card {
  border-radius: 20px;
  height: 90px;
  width: 200px;
  cursor: pointer;
  transition: all 0.2s;
}
.function-card.selected {
  border: 2px solid #09263F;
  opacity: 1;
}
.function-card.unselected {
  opacity: 0.3;
}
.function-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}
.icon-container {
  width: 15%;
}
.card-content {
  display: flex;
  flex-direction: column;
  width: 85%;
  align-items: center;
}
.custom-icon {
  margin-bottom: 4px;
  width: 70px;
  margin-left: 25px;
}
</style>
